import * as SharedIssueBaseSelectors from './shared-issue-base.selectors';

export {SharedIssueBaseSelectors};
